import { render, staticRenderFns } from "./DemoAccounts.vue?vue&type=template&id=136db36c"
import script from "./DemoAccounts.vue?vue&type=script&lang=js"
export * from "./DemoAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports